"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasUpdateStockTask = exports.hasOrderDeliveryCreationTask = exports.getOrderDeliveryLifecycle = exports.getOrderLifecycle = exports.getStockMovementDefaultLifecycle = exports.getDefaultLifecycle = void 0;
exports.findTransition = findTransition;
exports.checkTransitionPermission = checkTransitionPermission;
exports.getTransitionWithPermission = getTransitionWithPermission;
exports.getAllowedTransitions = getAllowedTransitions;
exports.getAllowedNextStatuses = getAllowedNextStatuses;
const lodash_1 = __importDefault(require("lodash"));
const types_1 = require("../types");
const getDefaultLifecycle = () => {
    const stockLifecycle = (0, exports.getStockMovementDefaultLifecycle)();
    const orderLifecycle = (0, exports.getOrderLifecycle)();
    const orderDeliveryLifecycle = (0, exports.getOrderDeliveryLifecycle)();
    const statuses = [
        ...stockLifecycle.statuses,
        ...orderLifecycle.statuses,
        ...orderDeliveryLifecycle.statuses,
    ];
    const creationRules = [
        ...stockLifecycle.creationRules,
        ...orderLifecycle.creationRules,
        ...orderDeliveryLifecycle.creationRules,
    ];
    const transitions = [
        ...stockLifecycle.transitions,
        ...orderLifecycle.transitions,
        ...orderDeliveryLifecycle.transitions,
    ];
    return {
        statuses,
        transitions,
        creation_status_rules: creationRules,
    };
};
exports.getDefaultLifecycle = getDefaultLifecycle;
const getStockMovementDefaultLifecycle = () => {
    const transitions = [];
    const statuses = [
        {
            id: "STOCK_MOVEMENT_APPROVED",
            label: "Stock approved",
            color: "#9E9E9E",
            entity: types_1.LIFE_CYCLE_ENTITY.STOCK_MOVEMENT,
        },
    ];
    const creationRules = [
        {
            entity: types_1.LIFE_CYCLE_ENTITY.STOCK_MOVEMENT,
            default_status_id: "STOCK_MOVEMENT_APPROVED",
            mobile_user_roles: undefined,
            web_user_roles: undefined,
            tasks: [
                {
                    id: types_1.LIFE_CYCLE_TASK.UPDATE_STOCK,
                    /**
                     * the parameter key should be unique
                     * Next step: add a dependancy object in IClient to handle the link between the storage type
                     */
                    parameters: [
                        {
                            key: "storage_types",
                            value: [types_1.STORAGE_TYPE.VAN, types_1.STORAGE_TYPE.WAREHOUSE],
                        },
                    ],
                },
            ],
        },
    ];
    return {
        statuses,
        transitions,
        creationRules,
    };
};
exports.getStockMovementDefaultLifecycle = getStockMovementDefaultLifecycle;
const getOrderLifecycle = () => {
    const statuses = [
        {
            id: "WAITING_TO_BE_CONFIRMED",
            label: "Waiting to be confirmed",
            color: "#9E9E9E",
            entity: types_1.LIFE_CYCLE_ENTITY.ORDER,
        },
        {
            id: "CONFIRMED",
            label: "Confirmed",
            color: "#9E9E9E",
            entity: types_1.LIFE_CYCLE_ENTITY.ORDER,
        },
    ];
    const transitions = [
        {
            from_status: "WAITING_TO_BE_CONFIRMED",
            to_status: "CONFIRMED",
            mobile_user_roles: [],
            web_user_roles: [],
            tasks: [
                {
                    id: types_1.LIFE_CYCLE_TASK.CREATE_ORDER_DELIVERY,
                },
            ],
        },
    ];
    const creationRules = [
        {
            entity: types_1.LIFE_CYCLE_ENTITY.ORDER,
            default_status_id: "WAITING_TO_BE_CONFIRMED",
            mobile_user_roles: undefined,
            web_user_roles: undefined,
        },
    ];
    return {
        statuses,
        transitions,
        creationRules,
    };
};
exports.getOrderLifecycle = getOrderLifecycle;
const getOrderDeliveryLifecycle = () => {
    const transitions = [];
    const statuses = [
        {
            id: "TO_PREPARE",
            label: "To prepare",
            color: "#9E9E9E",
            entity: types_1.LIFE_CYCLE_ENTITY.ORDER_DELIVERY,
        },
    ];
    const creationRules = [
        {
            entity: types_1.LIFE_CYCLE_ENTITY.ORDER_DELIVERY,
            default_status_id: "TO_PREPARE",
            mobile_user_roles: undefined,
            web_user_roles: undefined,
        },
    ];
    return {
        statuses,
        transitions,
        creationRules,
    };
};
exports.getOrderDeliveryLifecycle = getOrderDeliveryLifecycle;
const hasOrderDeliveryCreationTask = (tasks) => {
    return lodash_1.default.some(tasks, (task) => task.id === types_1.LIFE_CYCLE_TASK.CREATE_ORDER_DELIVERY);
};
exports.hasOrderDeliveryCreationTask = hasOrderDeliveryCreationTask;
const hasUpdateStockTask = (tasks) => {
    return lodash_1.default.some(tasks, (task) => task.id === types_1.LIFE_CYCLE_TASK.UPDATE_STOCK);
};
exports.hasUpdateStockTask = hasUpdateStockTask;
function findTransition(config, oldStatus, newStatus) {
    var _a;
    return lodash_1.default.find((_a = config === null || config === void 0 ? void 0 : config.transitions) !== null && _a !== void 0 ? _a : [], (transition) => transition.from_status === oldStatus && transition.to_status === newStatus);
}
function checkTransitionPermission(transition, mobileUserRole, webUserRole) {
    const hasPermission = (roles, userRole) => {
        if (!roles)
            return false;
        if (!userRole)
            return false;
        return lodash_1.default.some(roles, (role) => role === userRole);
    };
    if (!transition)
        return false;
    return (hasPermission(transition.mobile_user_roles, mobileUserRole) ||
        hasPermission(transition.web_user_roles, webUserRole));
}
function getTransitionWithPermission(config, oldStatus, newStatus, mobileUserRole, webUserRole) {
    const transition = findTransition(config, oldStatus, newStatus);
    if (!transition) {
        return {
            error: `No transition found from ${oldStatus} to ${newStatus}`,
            transition: undefined,
        };
    }
    if (!checkTransitionPermission(transition, mobileUserRole, webUserRole)) {
        return {
            error: `User does not have permission to transition from ${oldStatus} to ${newStatus}`,
            transition: undefined,
        };
    }
    return { transition, error: undefined };
}
function getAllowedTransitions(userRole, lifecycle, currentStatus) {
    var _a;
    return ((_a = lifecycle.transitions) !== null && _a !== void 0 ? _a : []).filter((transition) => {
        var _a, _b, _c, _d;
        const userRoleLower = lodash_1.default.toLower(userRole);
        const webUserRolesLower = lodash_1.default.map((_a = transition === null || transition === void 0 ? void 0 : transition.web_user_roles) !== null && _a !== void 0 ? _a : [], (role) => lodash_1.default.toLower(role));
        const mobileUserRolesLower = lodash_1.default.map((_b = transition === null || transition === void 0 ? void 0 : transition.mobile_user_roles) !== null && _b !== void 0 ? _b : [], (role) => lodash_1.default.toLower(role));
        const roleAllowed = ((_c = lodash_1.default.includes(webUserRolesLower, userRoleLower)) !== null && _c !== void 0 ? _c : false) ||
            ((_d = lodash_1.default.includes(mobileUserRolesLower, userRole)) !== null && _d !== void 0 ? _d : false);
        const fromMatches = transition.from_status === currentStatus;
        return roleAllowed && fromMatches;
    });
}
function getAllowedNextStatuses(userRole, lifecycle, entity, currentStatus) {
    const allowedTransitions = getAllowedTransitions(userRole, lifecycle, currentStatus);
    const allowedStatusIds = new Set(allowedTransitions.map((t) => t.to_status));
    return lodash_1.default.filter(lifecycle.statuses, (status) => allowedStatusIds.has(status.id) && status.entity === entity);
}
